import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import "./style/zigt.scss";
import "lazysizes";
import "./plugins/navbar";
import "./plugins/scrollindicator";
import Newspaper from "./components/Newspaper.vue";
import ConsentTool from "./components/ConsentTool.vue";
import VueCookies from "vue-cookies";
import VueGtm from "@gtm-support/vue2-gtm";

Vue.use(VueCookies);

Vue.use(VueGtm, {
  id: "GTM-MX7JT6W",
});

Vue.config.productionTip = false;

const headerHomeID = document.getElementById("swiperhome");
const newspaperID = document.getElementById("newspaper");
const casesID = document.getElementById("cases");
const casesArchiveID = document.getElementById("casesarchive");
const newsArchiveID = document.getElementById("newsarchive");
const youTubePlayerID = document.getElementById("playerYouTube");
const gifAsVideoID = document.getElementById("gifAsVideo");
const barBasicID = document.getElementById("basicBar");
const lineBasicID = document.getElementById("basicLine");
const chartMixID = document.getElementById("chartMix");
const chartPieID = document.getElementById("chartPie");
const searchResultsID = document.getElementById("searchresults");
const contactFormID = document.getElementById("contactform");
const consenttoolID = document.getElementById("consenttool");
const servicesID = document.getElementById("services");

if (typeof headerHomeID != "undefined" && headerHomeID != null) {
  import("./headerhome" /* webpackChunkName: "headerhome" */);
}

if (typeof casesID != "undefined" && casesID != null) {
  import("./cases" /* webpackChunkName: "cases" */);
}

if (typeof casesArchiveID != "undefined" && casesArchiveID != null) {
  import("./casesarchive" /* webpackChunkName: "casesarchive" */);
}

if (typeof newsArchiveID != "undefined" && newsArchiveID != null) {
  import("./newsarchive" /* webpackChunkName: "newsarchive" */);
}

if (typeof youTubePlayerID != "undefined" && youTubePlayerID != null) {
  import("./youtubeplayer" /* webpackChunkName: "youtubeplayer" */);
}

if (typeof gifAsVideoID != "undefined" && gifAsVideoID != null) {
  import("./lazyvideoasgif" /* webpackChunkName: "lazyvideoasgif" */);
}

if (typeof barBasicID != "undefined" && barBasicID != null) {
  import("./charts/barbasic" /* webpackChunkName: "barbasic" */);
}

if (typeof lineBasicID != "undefined" && lineBasicID != null) {
  import("./charts/linebasic" /* webpackChunkName: "linebasic" */);
}

if (typeof chartMixID != "undefined" && chartMixID != null) {
  import("./charts/chartmix" /* webpackChunkName: "chartmix" */);
}

if (typeof chartPieID != "undefined" && chartPieID != null) {
  import("./charts/chartpie" /* webpackChunkName: "chartpie" */);
}

if (typeof searchResultsID != "undefined" && searchResultsID != null) {
  import("./searchresults" /* webpackChunkName: "searchresults" */);
}

if (typeof contactFormID != "undefined" && contactFormID != null) {
  import("./contactform" /* webpackChunkName: "contactform" */);
}

if (typeof servicesID != "undefined" && servicesID != null) {
  import("./services" /* webpackChunkName: "services" */);
}

if (typeof newspaperID != "undefined" && newspaperID != null) {
  new Vue({
    render: (h) => h(Newspaper),
  }).$mount("#newspaper");
}

if (typeof consenttoolID != "undefined" && consenttoolID != null) {
  new Vue({
    render: (h) => h(ConsentTool),
  }).$mount("#consenttool");
}
